<div class="ziro-admin-page-content">
  <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
  <div class="col-md-10 offset-md-1" [hidden]="isLoading">
    <ziro-breadcrumbs>
      <ziro-breadcrumb-card-item>
        <div [innerHTML]="breadcrumbDescription | escapeHtml"></div>
      </ziro-breadcrumb-card-item>
    </ziro-breadcrumbs>

    @if (!isLoading) {
      <ziro-collapsible-section-card [isSwitchHidden]="true" [isCollapsible]="false">
        <div>
          <ul
            ngbNav
            #nav="ngbNav"
            [(activeId)]="active"
            (navChange)="onNavChange($event)"
            class="nav-tabs border-bottom-0"
            data-automation="dial-plan-management-nav-tabs"
          >
            <li [ngbNavItem]="tabs.GROUP_SETTINGS" [destroyOnHide]="false">
              <a ngbNavLink class="btn nav-link input-btn-start">
                @if (isGroupSettingsFormInvalid) {
                  <span
                    [class]="
                      ziroIcons.EXCLAMATION + ' fa animate__animated animate__infinite animate__tada text-danger me-1'
                    "
                  ></span>
                }
                <span>{{ 'tkey;dialplanmanagement.admin.group.navlink' | translate }}</span>
              </a>
              <ng-template ngbNavContent>
                <ziro-cisco-dial-plan-management-group-settings-form
                  [clusterOptions]="clusterOptions"
                  [siteOptions]="siteOptions"
                  [entity]="groupSettingsFormEntity"
                  [groupId]="dialPlanGroup.id"
                  [dialPlanGroups]="dialPlanGroups"
                  [siteSummary]="siteSummary"
                  (ziroFormsUpdate$)="onGroupSettingsFormUpdate($event)"
                ></ziro-cisco-dial-plan-management-group-settings-form>
              </ng-template>
            </li>

            <li
              [ngbNavItem]="tabs.DN_RANGES"
              [destroyOnHide]="false"
              [disabled]="!isGroupSettingsPopulated"
              [disableTooltip]="isGroupSettingsPopulated"
              [ngbTooltip]="'tkey;dialplanmanagement.admin.group.disabled_panes' | translate"
            >
              <a ngbNavLink class="btn nav-link">
                @if (isDnRangesFormInvalid) {
                  <span
                    [class]="
                      ziroIcons.EXCLAMATION + ' fa animate__animated animate__infinite animate__tada text-danger me-1'
                    "
                  ></span>
                }
                <span>{{ 'tkey;dialplanmanagement.admin.group.dnranges.navlink' | translate }}</span>
              </a>
              <ng-template ngbNavContent>
                @if (isFormVisible) {
                  <ziro-cisco-dial-plan-management-dn-ranges-form
                    [entity]="dnRangesFormEntity"
                    [cucmMetadata]="cucmMetadata"
                    [groupId]="dialPlanGroupId"
                    [clusterId]="clusterId"
                    [dialPlanGroups]="dialPlanGroups"
                    [siteSummary]="siteSummary"
                    [selectedSites]="selectedSites"
                    (ziroFormsUpdate$)="onDnRangesFormUpdate($event)"
                  ></ziro-cisco-dial-plan-management-dn-ranges-form>
                }
              </ng-template>
            </li>

            <li
              [ngbNavItem]="tabs.WRITE_TO_LDAP"
              [destroyOnHide]="false"
              [disabled]="!isGroupSettingsPopulated"
              [disableTooltip]="isGroupSettingsPopulated"
              [ngbTooltip]="'tkey;dialplanmanagement.admin.group.disabled_panes' | translate"
            >
              <a ngbNavLink class="btn nav-link">
                @if (isWriteToLdapFormInvalid) {
                  <span
                    [class]="
                      ziroIcons.EXCLAMATION + ' fa animate__animated animate__infinite animate__tada text-danger me-1'
                    "
                  ></span>
                }
                <span>{{ 'tkey;dialplanmanagement.admin.group.writeldap.navlink' | translate }}</span>
              </a>
              <ng-template ngbNavContent>
                @if (isFormVisible) {
                  <ziro-cisco-dial-plan-management-write-to-ldap-form
                    [entity]="writeToLdapFormEntity"
                    [ldapConfiguration]="ldapConfiguration"
                    (ziroFormsUpdate$)="onWriteToLdapFormUpdate($event)"
                  ></ziro-cisco-dial-plan-management-write-to-ldap-form>
                }
              </ng-template>
            </li>

            <li
              [ngbNavItem]="tabs.DID_RANGES"
              [destroyOnHide]="false"
              [disabled]="!isGroupSettingsPopulated"
              [disableTooltip]="isGroupSettingsPopulated"
              [ngbTooltip]="'tkey;dialplanmanagement.admin.group.disabled_panes' | translate"
            >
              <a ngbNavLink class="btn nav-link input-btn-end">
                @if (isDidRangesFormInvalid) {
                  <span
                    [class]="
                      ziroIcons.EXCLAMATION + ' fa animate__animated animate__infinite animate__tada text-danger me-1'
                    "
                  ></span>
                }
                <span>{{ 'tkey;dialplanmanagement.admin.group.didranges.navlink' | translate }}</span>
              </a>
              <ng-template ngbNavContent>
                @if (isFormVisible) {
                  <ziro-cisco-dial-plan-management-did-ranges-form
                    [entity]="didRangesFormEntity"
                    [cucmMetadata]="cucmMetadata"
                    [groupId]="dialPlanGroupId"
                    [clusterId]="clusterId"
                    [dialPlanGroups]="dialPlanGroups"
                    [siteSummary]="siteSummary"
                    (ziroFormsUpdate$)="onDidRangesFormUpdate($event)"
                  ></ziro-cisco-dial-plan-management-did-ranges-form>
                }
              </ng-template>
            </li>
          </ul>
          <div [ngbNavOutlet]="nav" class="mt-2"></div>
        </div>
      </ziro-collapsible-section-card>
    }
  </div>
</div>

<ziro-bottom-nav></ziro-bottom-nav>
